import { cardReadColumns, cardVisibleTo, learnerCards } from '../db/question-card-triggers'
import { actOnCard } from '../db/learner-actions'
import type { Tel } from '@w/tel'
import type { FlashcardsFeRouterCtx } from '../router/flashcards-fe.router-ctx'
import { writeWorkspace } from '../db/workspace-write'
import { scheduleFlashcardReview } from './flashcards-srs'


export async function writeTrainingReview(
  ctx: Pick<FlashcardsFeRouterCtx, 'clock' | 'writes' | 'db' | 'getUser' | 'afterCommit' | 'afterLocalCommit' | 'deviceId'>,
  workspaceId: string,
  input: { flashcardId: string; mark: number; ttaSeconds: number; tel: Tel; practiceRep?: number },
) {
  await writeWorkspace(ctx, workspaceId, async () => {
    const db = ctx.db(workspaceId).withTel(input.tel)
    const user = ctx.getUser()
    const flashcard = await db.query`
      SELECT ${cardReadColumns(db.flashcards)} FROM ${learnerCards(user.id)}
      WHERE ${db.flashcards.qid.eq(input.flashcardId)}
        AND ${cardVisibleTo(db.flashcards, user.id)}
    `.executeOne(db.flashcards.__selectSchema)
    if (!flashcard) throw new Error('Flashcard not found')

    const elapsedSeconds = Math.max(Math.round(input.ttaSeconds), 1)
    const now = new Date(ctx.clock.now())
    const scheduled = scheduleFlashcardReview({
      flashcard,
      mark: input.mark,
      ttaSeconds: elapsedSeconds,
      now,
    })

    await actOnCard(db, {
      userId: user.id, deviceId: ctx.deviceId, qid: flashcard.qid, now,
      translationLanguage: user.settings.lexicon?.nativeLanguage ?? 'en',
      practiceRep: input.practiceRep,
      action: { kind: 'reviewed', score: input.mark === 1 ? 1 : 0, durationSeconds: elapsedSeconds,
        result: { stage: scheduled.next.stage, repeatAt: scheduled.next.repeatAt.getTime(), ttaSeconds: scheduled.next.ttaSeconds, graduated: scheduled.graduated } },
    })
  })
}
